/* Nature trail checklist game, v8 (2026-10-14). Drop-in replacement for assets/nature-game.js.
   v8: seasonal items, place icons, clean step-3 states (fresh / in progress / ready / done / start again), no Save picture. */
(function () {
  var A = window.NONO_ART,
    root = document.querySelector("[data-scene-game]");
  if (!root || !A) return;
  var OV = {};
  try {
    OV = JSON.parse(
      (document.getElementById("sg-overrides") || {}).textContent || "{}",
    );
  } catch (e) {}
  function imgTag(u) {
    return (
      '<image href="' +
      u +
      '" x="0" y="0" width="100" height="100" preserveAspectRatio="xMidYMid meet"/>'
    );
  }
  Object.keys(OV.items || {}).forEach(function (k2) {
    A.items[k2] && OV.items[k2] && (A.items[k2].svg = imgTag(OV.items[k2]));
  });
  var baseScene = A.scene;
  A.scene = function (t, p) {
    var o = OV.places && OV.places[p],
      u = o && (o[t] || o.morning || o.afternoon || o.evening);
    return u
      ? '<image href="' +
          u +
          '" x="0" y="0" width="800" height="600" preserveAspectRatio="xMidYMid slice"/>'
      : baseScene(t, p);
  };
  function inlineOverrides() {
    var urls = [];
    (Object.keys(OV.items || {}).forEach(function (k2) {
      urls.push(OV.items[k2]);
    }),
      Object.keys(OV.places || {}).forEach(function (p) {
        for (var t in OV.places[p]) urls.push(OV.places[p][t]);
      }),
      urls.filter(Boolean).forEach(function (u) {
        fetch(u, { mode: "cors" })
          .then(function (r) {
            return r.blob();
          })
          .then(function (bl) {
            var fr = new FileReader();
            ((fr.onload = function () {
              (Object.keys(A.items).forEach(function (k2) {
                A.items[k2].svg = A.items[k2].svg.split(u).join(fr.result);
              }),
                Object.keys(OV.places || {}).forEach(function (p) {
                  for (var t in OV.places[p])
                    OV.places[p][t] === u && (OV.places[p][t] = fr.result);
                }));
            }),
              fr.readAsDataURL(bl));
          })
          .catch(function () {});
      }));
  }
  inlineOverrides();
  var NS = "http://www.w3.org/2000/svg",
    UKEY = "nono-day-unlocked",
    KEY = "nono-day-v4",
    MAX = 60,
    W = 800,
    H = 600,
    TOTAL = 0,
    svg = root.querySelector(".sg-scene"),
    bg = svg.querySelector(".sg-bg"),
    layer = svg.querySelector(".sg-items"),
    selBox = svg.querySelector(".sg-sel"),
    tray = root.querySelector(".sg-tray"),
    tabs = root.querySelector(".sg-tabs"),
    live = root.querySelector(".sg-live"),
    hint = root.querySelector(".sg-hint"),
    tools = root.querySelectorAll("[data-tool]"),
    list = root.querySelector(".sg-list"),
    state = {
      place: "garden",
      time: "morning",
      items: [],
      ticks: {},
      tab: "minibeasts",
    },
    sel = null,
    uid = 1,
    unlocked = !1;
  try {
    unlocked = localStorage.getItem(UKEY) === "1";
  } catch (e) {}
  var reduce =
    window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  try {
    var sv = JSON.parse(localStorage.getItem(KEY));
    if (sv && sv.items) {
      for (var k in sv) state[k] = sv[k];
      ((state.items = state.items.filter(function (it) {
        return A.items[it.type];
      })),
        state.items.forEach(function (it) {
          uid = Math.max(uid, it.id + 1);
        }));
    }
  } catch (e) {}
  /* v8.1: optional child's first name. Data minimisation: first name only, kept in this device's saved state
     (localStorage) and printed on the PDF. Never sent to Shopify or any server. */
  function cleanName(v) {
    return String(v || "").normalize("NFC").replace(/[^\p{L}\p{M}' \u2019-]/gu, "").replace(/\s+/g, " ").replace(/^[\s'\u2019-]+/, "").slice(0, 22);
  }
  function titleFor(n) {
    n = cleanName(n).trim();
    if (!n) return "Nature trail checklist";
    return n + (/s$/i.test(n) ? "\u2019" : "\u2019s") + " nature trail checklist";
  }
  var tagEl = null;
  function placeTag() {
    if (!tagEl) return;
    var st2 = root.querySelector(".sg-stage"), sv = st2 && st2.querySelector(".sg-scene");
    if (!sv) return;
    var a = st2.getBoundingClientRect(), r = sv.getBoundingClientRect(), hn = root.querySelector(".sg-hint"),
      lift = hn && !hn.hidden ? hn.offsetHeight + 8 : 0;
    tagEl.style.left = r.left - a.left + r.width / 2 + "px";
    tagEl.style.top = r.bottom - a.top - 10 - lift - tagEl.offsetHeight + "px";
  }
  function paintTag(n) {
    var st2 = root.querySelector(".sg-stage");
    if (!st2) return;
    if (!tagEl) {
      tagEl = document.createElement("div");
      tagEl.className = "sg-nametag";
      tagEl.setAttribute("aria-hidden", "true");
      st2.appendChild(tagEl);
      window.ResizeObserver && new ResizeObserver(placeTag).observe(st2);
      window.addEventListener("resize", placeTag);
    }
    tagEl.textContent = n ? n + (/s$/i.test(n) ? "\u2019" : "\u2019s") + " picture" : "";
    tagEl.classList.toggle("long", n.length > 12);
    tagEl.classList.toggle("xlong", n.length > 17);
    tagEl.hidden = !n;
    placeTag();
  }
  function paintName() {
    var h = root.querySelector("#sg-out-h"), n = cleanName(state.kid).trim();
    paintTag(n);
    if (!h) return;
    var pr = h.querySelector(".sg-print-only"), w = h.querySelector(".sg-out-word");
    pr && (pr.textContent = titleFor(n));
    w && (w.textContent = n ? n + (/s$/i.test(n) ? "\u2019" : "\u2019s") + " checklist" : "Your checklist");
  }
  (function () {
    var where = root.querySelector(".sg-where");
    if (!where || root.querySelector(".sg-kid")) return;
    var box = document.createElement("div");
    box.className = "sg-kid";
    box.innerHTML = '<label for="sg-kid-in">Child\u2019s first name <span>(optional)</span></label>' +
      '<input id="sg-kid-in" type="text" maxlength="22" autocomplete="off" autocapitalize="words" spellcheck="false" placeholder="e.g. Flo" aria-describedby="sg-kid-note">' +
      '<p id="sg-kid-note">Goes on your checklist. It stays on this device.</p>';
    where.appendChild(box);
    var inp = box.querySelector("input");
    inp.value = cleanName(state.kid);
    inp.addEventListener("input", function () {
      var c = cleanName(inp.value);
      c !== inp.value && (inp.value = c);
      state.kid = c.trim();
      paintName();
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    });
    paintName();
  })();
  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
    typeof restartState === "function" && clr && restartState();
    typeof gateHint === "function" && !state.done && gateHint();
  }
  function say(t) {
    ((live.textContent = ""),
      setTimeout(function () {
        live.textContent = t;
      }, 30));
  }
  function el(n, a) {
    var e = document.createElementNS(NS, n);
    for (var k2 in a) e.setAttribute(k2, a[k2]);
    return e;
  }
  function icon(k2, cls) {
    return (
      '<svg class="' +
      (cls || "") +
      '" viewBox="-6 -6 112 112" aria-hidden="true" focusable="false">' +
      A.items[k2].svg +
      "</svg>"
    );
  }
  function seasonal(k2) {
    return !A.inSeason || A.inSeason(k2);
  }
  /* v8.1: safety line above the checklist */
  (function () {
    var out = root.querySelector(".sg-out"), lede = out && out.querySelector(".sg-lede");
    if (!out || out.querySelector(".sg-safety")) return;
    var p = document.createElement("p");
    p.className = "sg-safety";
    p.textContent = A.safety || "Look, don\u2019t touch or eat.";
    lede ? lede.after(p) : out.appendChild(p);
  })();
  /* v8.7: points + time-of-day explainer in the page intro, and email placeholder */
  (function () {
    var intro = root.querySelector(".sg-intro"), lede = intro && intro.querySelector(".sg-lede");
    /* v8.7c: append the points sentence to the existing intro paragraph (one paragraph). Never duplicates:
       skipped if the lede (Liquid setting) already mentions earning points. */
    if (lede && !/earn points/i.test(lede.textContent)) {
      var am = amazingNames();
      lede.textContent = lede.textContent.replace(/\s+$/, "") + " Spot things to earn points: rarer finds score more, and " +
        (am.length ? "the " + am[0] + " is" : "the rarest are") + " worth 5. Pick evening to look for owls, bats and badgers.";
    }
    var em = root.querySelector("#sg-email");
    em && (em.placeholder = "name@example.com");
  })();
  var potEl = null;
  function potential(inScene) {
    if (!A.pipSVG) return;
    if (!potEl) {
      var host = root.querySelector(".sg-panel");
      if (!host) return;
      potEl = document.createElement("p");
      potEl.className = "sg-potential";
      potEl.setAttribute("aria-live", "polite");
      host.appendChild(potEl);
    }
    paintTotaller();
    if (!root.querySelector(".sg-key")) {
      var sf = root.querySelector(".sg-safety"), key = document.createElement("p");
      key.className = "sg-key";
      var expl = document.createElement("p");
      expl.className = "sg-explain";
      expl.innerHTML = "Tick each thing you spot and we\u2019ll add up your points. <b>Easy spot 1 point, Good spot 2, Great spot 3, Amazing spot 5.</b> " +
        "Reach 5 points for Explorer, 12 for Tracker and 20 for Wild Ranger.";
      sf && sf.after(expl);
      sf = expl;
      key.innerHTML = LEVELS.map(function (kv) {
        var one = function (x) { return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' + x + "</svg>"; }, h = "";
        if (kv[0] >= 5) h = one(A.starSVG); else for (var i = 0; i < kv[0]; i++) h += one(A.pipSVG);
        return '<span><span class="sg-pips" data-n="' + kv[0] + '">' + h + "</span>" + kv[1] + "</span>";
      }).join("");
      sf && sf.after(key);
    }
    var sum = 0;
    Object.keys(inScene).forEach(function (k2) {
      seasonal(k2) && (sum += pts(k2));
    });
    potEl.innerHTML =
      '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' + A.pipSVG + "</svg>" +
      (sum
        ? "<span>Your trail could earn up to <b>" + sum + "</b> points</span>"
        : "<span>Add things to your picture to see your points</span>");
  }
  function amazingNames() {
    return Object.keys(A.items).filter(function (k2) { return seasonal(k2) && pts(k2) >= 5; }).map(function (k2) { return A.items[k2].name.toLowerCase(); });
  }
  var totEl = null;
  function paintTotaller() {
    var out = root.querySelector(".sg-out");
    if (!out || !A.badges) return;
    if (!totEl) {
      totEl = document.createElement("div");
      totEl.className = "sg-tally";
      totEl.setAttribute("role", "status");
      totEl.setAttribute("aria-live", "polite");
      var bar = out.querySelector(".sg-bar");
      (bar || out.firstChild).after(totEl);
    }
    var sum = 0;
    Object.keys(state.ticks).forEach(function (k2) { state.ticks[k2] && seasonal(k2) && (sum += pts(k2)); });
    var got = null, next = null;
    A.badges.forEach(function (b) { sum >= b[1] ? (got = b) : !next && (next = b); });
    totEl.innerHTML =
      '<div class="sg-tally-n"><span>Points so far</span><b>' + sum + "</b></div>" +
      '<ol class="sg-tally-b">' + A.badges.map(function (b) {
        return '<li class="' + (sum >= b[1] ? "on" : "") + '"><b>' + b[0] + "</b><span>" + b[1] + "+</span></li>";
      }).join("") + "</ol>" +
      '<p class="sg-tally-msg">' + (next ? (got ? "You\u2019re " + (/^[AEIOU]/.test(got[0]) ? "an " : "a ") + got[0] + "! " : "") + (next[1] - sum) + " more " + (next[1] - sum == 1 ? "point" : "points") + " to " + next[0] + "." : "Wild Ranger! You\u2019ve earned every badge.") + "</p>";
  }
  function countTotal() {
    TOTAL = Object.keys(A.items).filter(seasonal).length;
    return TOTAL;
  }
  countTotal();
  /* "In your picture" marker, text-free: a soft yellow row tint (Sam's pick). "ring" and "dot" remain as options. Swap with data-marker="tint" on the [data-scene-game] element, or window.NONO_MARKER before this script. */
  var MARKER = root.getAttribute("data-marker") || window.NONO_MARKER || "tint";
  root.setAttribute("data-marker", MARKER);
  /* points: 1-3 acorn pips, or a gold star for the 5-point super-rare finds */
  function pts(k2) {
    return (A.items[k2] && A.items[k2].pts) || 1;
  }
  var LEVELS = [[1, "Easy spot"], [2, "Good spot"], [3, "Great spot"], [5, "Amazing spot!"]];
  function levelName(n) {
    for (var i = LEVELS.length - 1; i >= 0; i--) if (n >= LEVELS[i][0]) return LEVELS[i][1];
    return LEVELS[0][1];
  }
  function pips(k2) {
    var n = pts(k2),
      one = function (svgIn) {
        return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' + svgIn + "</svg>";
      },
      h = "";
    if (!A.pipSVG) return "";
    if (n >= 5) h = one(A.starSVG);
    else for (var i = 0; i < n; i++) h += one(A.pipSVG);
    return '<span class="sg-pips" data-n="' + n + '" title="' + levelName(n) + ", " + n + (n == 1 ? " point" : " points") + '" aria-hidden="true">' + h + '</span><span class="sg-vh">, ' + levelName(n).replace("!", "") + ", " + n + (n == 1 ? " point" : " points") + "</span>";
  }
  function inGroup(g) {
    if (g === "season") {
      var se = A.seasons && A.seasons[A.seasonKey];
      return se
        ? se.items.filter(function (k2) {
            return A.items[k2] && seasonal(k2);
          })
        : [];
    }
    return Object.keys(A.items).filter(function (k2) {
      return A.items[k2].g === g && seasonal(k2);
    });
  }
  root.querySelectorAll('input[name="sg-time"]').forEach(function (r) {
    ((r.checked = r.value === state.time),
      r.addEventListener("change", function () {
        ((state.time = r.value),
          drawBg(),
          save(),
          say(A.times[r.value].label + "."));
      }));
  });
  var places = root.querySelector(".sg-places");
  Object.keys(A.places).forEach(function (p) {
    var l = document.createElement("label");
    l.innerHTML =
      '<input type="radio" name="sg-place" value="' +
      p +
      '"><span>' +
      (A.placeIcons && A.placeIcons[p]
        ? '<svg viewBox="-6 -6 112 112" aria-hidden="true" focusable="false">' +
          A.placeIcons[p] +
          "</svg>"
        : icon({ woods: "pine", garden: "daisy", park: "oak", pond: "mallard" }[p] || "oak")) +
      "<b>" +
      A.places[p] +
      "</b></span>";
    var r = l.querySelector("input");
    ((r.checked = p === state.place),
      r.addEventListener("change", function () {
        ((state.place = p),
          drawBg(),
          save(),
          say(A.places[p] + ". Your things are still here."));
      }),
      places.appendChild(l));
  });
  var PAL = {
      morning: ["#FBF1E4", "#F6F3EA"],
      afternoon: ["#EAF2F4", "#F4F7F4"],
      evening: ["#F4E6EA", "#F7EFEA"],
    },
    HILL = {
      woods: ["#DCE6D2", "#C9D8BC"],
      garden: ["#E2EAD6", "#D2DFC2"],
      park: ["#E0E9D4", "#CEDDBD"],
      pond: ["#D9E6E2", "#C4D8D2"],
    };
  function mix(a, b, t) {
    var x = parseInt(a.slice(1), 16),
      y = parseInt(b.slice(1), 16),
      o = "#";
    return (
      [16, 8, 0].forEach(function (s) {
        var v = Math.round(((x >> s) & 255) * (1 - t) + ((y >> s) & 255) * t);
        o += ("0" + v.toString(16)).slice(-2);
      }),
      o
    );
  }
  function band() {
    var b = document.querySelector(".sg-sky");
    if (b) {
      var p = PAL[state.time] || PAL.morning,
        h = HILL[state.place] || HILL.garden,
        se = A.seasons[A.seasonKey],
        set = function (id, a, v) {
          var e = b.querySelector("#" + id);
          e && e.setAttribute(a, v);
        };
      (set("sg-k1", "stop-color", p[0]),
        set("sg-k2", "stop-color", p[1]),
        set("sg-h1", "fill", mix(h[0], se.hill, 0.45)),
        set("sg-h2", "fill", mix(h[1], se.ground, 0.35)));
    }
  }
  function setSeason(k2) {
    if (A.seasons[k2]) {
      ((A.seasonKey = k2),
        root.querySelectorAll('input[name="sg-season"]').forEach(function (r) {
          r.checked = r.value === k2;
        }));
      var st = tabs.querySelector(".sg-tab-season");
      if (st) {
        var g = seasonTab();
        (st.setAttribute("aria-label", g[1]),
          (st.innerHTML = icon(g[3]) + "<span>" + g[2] + "</span>"));
      }
      (root.querySelectorAll(".sg-season-name").forEach(function (e) {
        e.textContent = A.seasons[k2].label.toLowerCase();
      }),
        places.querySelectorAll("label").forEach(function (l) {
          var r = l.querySelector("input"),
            s = l.querySelector("svg");
          s &&
            r &&
            s.getAttribute("viewBox") === "0 0 800 600" &&
            (s.innerHTML = A.scene("afternoon", r.value));
        }));
    }
  }
  (root.querySelectorAll('input[name="sg-season"]').forEach(function (r) {
    ((r.checked = r.value === A.seasonKey),
      r.addEventListener("change", function () {
        (setSeason(r.value),
          drawBg(),
          state.tab === "season" && drawTray(),
          say(A.seasons[r.value].label + "."));
      }));
  }),
    setTimeout(function () {
      setSeason(A.seasonKey);
    }, 0));
  function drawBg() {
    (band(),
      A.places[state.place] || (state.place = "garden"),
      (bg.innerHTML = A.scene(state.time, state.place)),
      svg.setAttribute(
        "aria-label",
        "Your picture: " +
          A.places[state.place] +
          ", " +
          A.times[state.time].label.toLowerCase() +
          ", " +
          state.items.length +
          (state.items.length == 1 ? " thing" : " things"),
      ));
  }
  function seasonTab() {
    var se = A.seasons[A.seasonKey];
    return [
      "season",
      "This season (" + se.label.toLowerCase() + ")",
      "This season",
      se.items[0],
    ];
  }
  if (state.tab !== "season" && !inGroup(state.tab).length) state.tab = A.groups[0][0];
  A.groups.forEach(function (g) {
    if (g[0] !== "season" && !inGroup(g[0]).length) return;
    var b = document.createElement("button");
    ((b.type = "button"),
      (b.className = "sg-tab" + (g[0] === "season" ? " sg-tab-season" : "")),
      (b.dataset.g = g[0]),
      b.setAttribute("aria-pressed", g[0] === state.tab ? "true" : "false"),
      b.setAttribute("aria-label", g[1]),
      (b.innerHTML = icon(g[3]) + "<span>" + g[2] + "</span>"),
      b.addEventListener("click", function () {
        ((state.tab = g[0]), drawTray(), save());
      }),
      tabs.appendChild(b));
  });
  var HINTS = { trees: "Tap a tree to add it.", fungi: "Tap a flower to add it.", finds: "Tap a find to add it." };
  function drawTray() {
    hint && (hint.textContent = HINTS[state.tab] || "Tap a creature to add it.");
    (tabs.querySelectorAll(".sg-tab").forEach(function (b) {
      b.setAttribute(
        "aria-pressed",
        b.dataset.g === state.tab ? "true" : "false",
      );
    }),
      (tray.innerHTML = ""),
      inGroup(state.tab).forEach(function (k2) {
        var b = document.createElement("button");
        ((b.type = "button"),
          (b.className = "sg-add"),
          (b.innerHTML = icon(k2) + "<span>" + A.items[k2].short + "</span>"),
          b.setAttribute("aria-label", "Add " + A.items[k2].name),
          b.addEventListener("click", function () {
            add(k2);
          }),
          tray.appendChild(b));
      }));
  }
  function spot(k2) {
    var z = A.items[k2].zone,
      n = state.items.length,
      j = function (m, r) {
        return (n * m) % r;
      };
    if (z === "sky") return { x: 160 + j(173, 480), y: 80 + j(61, 110) };
    if (z === "tree") {
      var L = n % 2;
      return { x: (L ? 80 : 700) + j(37, 60), y: 150 + j(53, 120) };
    }
    return z === "pond"
      ? { x: 520 + j(71, 210), y: 470 + j(29, 70) }
      : z === "ground"
        ? { x: 70 + j(131, 420), y: 440 + j(47, 120) }
        : { x: 240 + j(97, 320), y: 250 + j(83, 250) };
  }
  function add(k2) {
    if (state.items.length >= MAX) {
      say("That\u2019s a full scene. Remove something to add more.");
      return;
    }
    var p = spot(k2),
      it = { id: uid++, type: k2, x: p.x, y: p.y, s: +(A.items[k2].s * 0.72).toFixed(2), f: 0 };
    (state.items.push(it),
      render(it, !0),
      select(it.id, !1),
      save(),
      drawBg(),
      drawList(),
      say(
        A.items[k2].name + " added. Drag it to move it, or use the arrow keys.",
      ));
  }
  function render(it, pop) {
    var g = el("g", {
        class: "sg-item" + (pop && !reduce ? " pop" : ""),
        tabindex: "0",
        role: "img",
        "aria-label": A.items[it.type].name,
        "data-id": it.id,
      }),
      inner = el("g", {});
    return (
      (inner.innerHTML =
        '<rect x="-22" y="-22" width="144" height="144" fill="transparent"/>' +
        A.items[it.type].svg),
      g.appendChild(inner),
      layer.appendChild(g),
      place(it, g),
      g
    );
  }
  function gOf(id) {
    return layer.querySelector('[data-id="' + id + '"]');
  }
  function find(id) {
    for (var i = 0; i < state.items.length; i++)
      if (state.items[i].id == id) return state.items[i];
  }
  function place(it, g) {
    ((g = g || gOf(it.id)),
      g.firstChild.setAttribute(
        "transform",
        "translate(" +
          it.x +
          " " +
          it.y +
          ") rotate(" +
          (it.r || 0) +
          ") scale(" +
          (it.f ? -it.s : it.s) +
          " " +
          it.s +
          ") translate(-50 -50)",
      ),
      sel == it.id && box(it));
  }
  function box(it) {
    var h = 58 * it.s + 6;
    (selBox.setAttribute("x", it.x - h),
      selBox.setAttribute("y", it.y - h),
      selBox.setAttribute("width", 2 * h),
      selBox.setAttribute("height", 2 * h),
      (selBox.style.display = ""));
  }
  function select(id, focus) {
    sel = id;
    var it = find(id);
    (layer.querySelectorAll(".sg-item").forEach(function (g) {
      g.classList.toggle("on", g.dataset.id == id);
    }),
      it
        ? (box(it), focus !== !1 && gOf(id).focus({ preventScroll: !0 }))
        : (selBox.style.display = "none"),
      tools.forEach(function (b) {
        b.disabled = !it;
      }),
      (hint.hidden = state.items.length > 0), placeTag());
  }
  var drag = null;
  function pt(e) {
    var p = svg.createSVGPoint();
    return (
      (p.x = e.clientX),
      (p.y = e.clientY),
      p.matrixTransform(svg.getScreenCTM().inverse())
    );
  }
  (svg.addEventListener("pointerdown", function (e) {
    var g = e.target.closest(".sg-item");
    if (!g) {
      select(null);
      return;
    }
    var it = find(g.dataset.id);
    select(it.id);
    var p = pt(e);
    ((drag = { it: it, dx: it.x - p.x, dy: it.y - p.y, id: e.pointerId }),
      svg.setPointerCapture(e.pointerId),
      g.classList.add("lift"),
      e.preventDefault());
  }),
    svg.addEventListener("pointermove", function (e) {
      if (!(!drag || e.pointerId !== drag.id)) {
        var p = pt(e);
        ((drag.it.x = Math.max(0, Math.min(W, p.x + drag.dx))),
          (drag.it.y = Math.max(0, Math.min(H, p.y + drag.dy))),
          place(drag.it));
      }
    }));
  function end() {
    if (drag) {
      var g = gOf(drag.it.id);
      (g && g.classList.remove("lift"), (drag = null), save());
    }
  }
  (svg.addEventListener("pointerup", end),
    svg.addEventListener("pointercancel", end),
    layer.addEventListener("focusin", function (e) {
      var g = e.target.closest(".sg-item");
      g && sel != g.dataset.id && select(g.dataset.id, !1);
    }),
    svg.addEventListener("keydown", function (e) {
      var it = find(sel);
      if (it) {
        var d = e.shiftKey ? 40 : 10,
          used = !0;
        if (e.key === "ArrowLeft") it.x = Math.max(0, it.x - d);
        else if (e.key === "ArrowRight") it.x = Math.min(W, it.x + d);
        else if (e.key === "ArrowUp") it.y = Math.max(0, it.y - d);
        else if (e.key === "ArrowDown") it.y = Math.min(H, it.y + d);
        else {
          if (e.key === "+" || e.key === "=") return tool("bigger");
          if (e.key === "-") return tool("smaller");
          if (e.key === "f" || e.key === "F") return tool("flip");
          if (e.key === "r" || e.key === "R") return tool("rotate");
          if (e.key === "Delete" || e.key === "Backspace")
            return tool("remove");
          e.key === "Escape" ? select(null) : (used = !1);
        }
        used && (e.preventDefault(), place(it), save());
      }
    }),
    tools.forEach(function (b) {
      b.addEventListener("click", function () {
        tool(b.dataset.tool);
      });
    }));
  function tool(t) {
    var it = find(sel);
    if (it) {
      var g = gOf(it.id),
        name = A.items[it.type].short;
      if (
        (t === "bigger" &&
          ((it.s = Math.min(2.6, +(it.s * 1.2).toFixed(2))),
          say(name + " bigger.")),
        t === "smaller" &&
          ((it.s = Math.max(0.3, +(it.s / 1.2).toFixed(2))),
          say(name + " smaller.")),
        t === "flip" && ((it.f = it.f ? 0 : 1), say(name + " flipped.")),
        t === "rotate" &&
          ((it.r = ((it.r || 0) + 15) % 360), say(name + " rotated.")),
        t === "front" &&
          (layer.appendChild(g),
          state.items.push(state.items.splice(state.items.indexOf(it), 1)[0]),
          g.focus({ preventScroll: !0 }),
          say(name + " moved to the front.")),
        t === "remove")
      ) {
        (g.remove(),
          state.items.splice(state.items.indexOf(it), 1),
          select(null),
          save(),
          drawBg(),
          drawList(),
          say(name + " removed."));
        return;
      }
      (place(it), save());
    }
  }
  var wide = window.matchMedia("(min-width:1000px)").matches;
  function drawList() {
    var inScene = {};
    state.items.forEach(function (it) {
      inScene[it.type] = 1;
    });
    var open = {};
    list.querySelectorAll("details").forEach(function (d) {
      open[d.dataset.g] = d.open;
    });
    var html = "",
      got = 0;
    (A.groups.forEach(function (g, gi) {
      var ks = inGroup(g[0]),
        n = ks.filter(function (k2) {
          return state.ticks[k2];
        }).length;
      if (g[0] === "season" || !ks.length) return;
      got += n;
      var isOpen = g[0] in open ? open[g[0]] : wide || gi === 0;
      ((html +=
        '<details data-g="' +
        g[0] +
        '"' +
        (isOpen ? " open" : "") +
        "><summary>" +
        icon(g[3], "sg-gicon") +
        '<span class="sg-gname">' +
        g[1] +
        '</span><span class="sg-gcount">' +
        n +
        " of " +
        ks.length +
        "</span></summary><ul>"),
        ks.forEach(function (k2) {
          var a = A.items[k2];
          html +=
            "<li" + (inScene[k2] ? ' class="sg-in"' : "") + '><label><input type="checkbox" data-t="' +
            k2 +
            '"' +
            (state.ticks[k2] ? " checked" : "") +
            '><span class="sg-box" aria-hidden="true"></span><span class="sg-ic">' +
            icon(k2) +
            "</span>" +
            '<span class="sg-txt"><b>' +
            a.name +
            pips(k2) +
            "</b><small>" +
            a.find +
            "</small>" +
            (inScene[k2] ? '<span class="sg-vh"> (in your picture)</span>' : "") +
            "</span></label></li>";
        }),
        (html += "</ul></details>"));
    }),
      (list.innerHTML = html),
      root.querySelectorAll(".sg-total").forEach(function (t) {
        t.textContent =
          got === TOTAL
            ? "All " + TOTAL + " found!"
            : got + " of " + TOTAL + " found";
      }),
      (root.querySelector(".sg-bar i").style.width = (got / TOTAL) * 100 + "%"),
      root.querySelector(".sg-bar").setAttribute("aria-valuenow", got),
      potential(inScene),
      root.querySelector(".sg-bar").setAttribute("aria-valuemax", TOTAL));
  }
  (list.addEventListener("change", function (e) {
    var t = e.target.dataset.t;
    if (t) {
      ((state.ticks[t] = e.target.checked), save(), drawList());
      var c = list.querySelector('[data-t="' + t + '"]');
      (c && c.focus(),
        e.target.checked &&
          say(
            "Spotted: " +
              A.items[t].name +
              "." +
              (Object.keys(state.ticks).filter(function (k2) {
                return state.ticks[k2] && seasonal(k2);
              }).length === TOTAL
                ? " All " + TOTAL + " found. Well done!"
                : ""),
          ));
    }
  }),
    list.addEventListener("toggle", function () {}, !0));
  var gate = root.querySelector(".sg-gate"),
    form = gate.querySelector("form"),
    email = form.querySelector('[name="contact[email]"]'),
    err = form.querySelector(".sg-err"),
    done = gate.querySelector(".sg-done"),
    cbox = form.querySelector(".sg-consent input");
  /* Step 3 states
     fresh       no things yet: email form shown, with a nudge to add things first
     in progress things added: email form shown
     done        email accepted for THIS list: download + print shown (state.done, saved with the list)
     start again clears the list and state.done, so the email form comes back (prefilled if we know the email)
     refresh     restores exactly the saved list and its done flag; an old global "unlocked" flag no longer forces "ready". */
  var AKEY = "nono-trail-adult",
    sub = gate.querySelector(".sg-sub"),
    SUB0 = sub ? sub.textContent : "";
  /* v8.2 step-3 variant flag. ONE switch:
       "interim" (default) no email backend or live code yet: one benefit (the print-friendly checklist), unlocks on screen only.
       "full"    email sending + WELCOME10 live: both benefits, the code on screen and "Check your inbox".
     Set data-gate-mode="full" on the [data-scene-game] element (or window.NONO_GATE_MODE = "full" before this script).
     data-gate-code="WELCOME10" sets the code shown in full mode. */
  var GATE = (root.getAttribute("data-gate-mode") || window.NONO_GATE_MODE || "interim").toLowerCase() === "full" ? "full" : "interim",
    CODE = (root.getAttribute("data-gate-code") || window.NONO_GATE_CODE || "WELCOME10").replace(/[^A-Z0-9-]/gi, "").toUpperCase();
  root.setAttribute("data-gate-mode", GATE);
  (function () {
    var tick = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="#EAF1E4"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#2F6B3A" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var B = ["A print-friendly checklist to take on your adventure"];
    GATE === "full" && B.push("A 10% off code to use anytime at Nono Problemo");
    /* seasons news rides on the unticked opt-in (Shopify customer form), which works in both modes */

    if (sub) {
      SUB0 = "Add your email and you\u2019ll get:";
      sub.textContent = SUB0;
      var ul = document.createElement("ul");
      ul.className = "sg-benefits";
      ul.innerHTML = B.map(function (t) { return "<li>" + tick + "<span>" + t + "</span></li>"; }).join("");
      sub.after(ul);
    }
    var head = done.querySelector("b");
    head && (head.textContent = "\u2713 Your checklist is ready");
    var opt = form.querySelector(".sg-opt > span:last-child");
    opt && (opt.textContent = "Send me occasional Nono news and play ideas (optional, unsubscribe anytime)");
    var fl = form.querySelector('label.fld[for="sg-email"]');
    fl && (fl.textContent = "Your email");
    /* CTA: works in both modes (nothing is "sent" in interim, and "unlock" sounds like a paywall) */
    var cta = form.querySelector('[type="submit"]');
    cta && (cta.textContent = "Get my printable checklist");
    if (GATE === "full") {
      var box = document.createElement("div");
      box.className = "sg-code";
      box.innerHTML = '<p class="sg-code-l">Your 10% off code</p><div class="sg-code-row"><span class="sg-code-v">' + CODE +
        '</span><button type="button" class="sg-code-copy">Copy</button></div><p class="sg-code-n">Use it anytime at Nono Problemo. Works on sale prices too.</p>' +
        '<p class="sg-code-n sg-inbox">Check your inbox. We\u2019ve emailed you the code and your checklist.</p>';
      var actsRow = done.querySelector(".sg-done-acts");
      actsRow ? actsRow.after(box) : done.appendChild(box);
      box.querySelector(".sg-code-copy").addEventListener("click", function () {
        var b2 = this;
        try { navigator.clipboard.writeText(CODE); } catch (e) {}
        b2.textContent = "Copied";
        say("Code copied.");
        setTimeout(function () { b2.textContent = "Copy"; }, 2000);
      });
    }
  })();
  function rememberEmail(v) {
    try {
      localStorage.setItem(AKEY, v);
    } catch (e) {}
  }
  function knownEmail() {
    try {
      return localStorage.getItem(AKEY) || "";
    } catch (e) {
      return "";
    }
  }
  function setUnlocked() {
    unlocked = !0;
    state.done = !0;
    save();
    ((form.hidden = !0),
      (done.hidden = !1),
      acts.forEach(function (b) {
        b.setAttribute("aria-disabled", "false");
      }));
  }
  function showGate() {
    unlocked = !1;
    state.done = !1;
    save();
    form.hidden = !1;
    done.hidden = !0;
    var note = done.querySelector(".sg-mailnote");
    note && (note.hidden = !0);
    acts.forEach(function (b) {
      b.setAttribute("aria-disabled", "true");
    });
    /* v8.7: never prefill the email; the field shows a placeholder instead */
    gateHint();
  }
  function gateHint() {
    if (!sub) return;
    sub.textContent = SUB0;
  }
  function bad(msg) {
    ((err.textContent = msg),
      (err.hidden = !1),
      email.setAttribute("aria-invalid", "true"),
      email.focus(),
      say(msg));
  }
  var sbtn = form.querySelector('[type="submit"]');
  (sbtn.addEventListener(
    "click",
    function (e) {
      var opt = form.querySelector(".sg-optin-box");
      if (!(!opt || opt.checked)) {
        (e.preventDefault(), e.stopImmediatePropagation());
        var v = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v))
          return bad("Please check the email address.");
        ((err.hidden = !0),
          email.removeAttribute("aria-invalid"),
          rememberEmail(v),
          setUnlocked(),
          done.focus(),
          say("Your list is ready. Download the PDF or print it."));
      }
    },
    !0,
  ),
    email.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        var opt = form.querySelector(".sg-optin-box");
        opt && !opt.checked && (e.preventDefault(), sbtn.click());
      }
    }),
    form.addEventListener(
      "submit",
      function (e) {
        var v = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          (e.preventDefault(),
            e.stopImmediatePropagation(),
            bad("Please check the email address."));
          return;
        }
        ((err.hidden = !0), email.removeAttribute("aria-invalid"));
        var opt = form.querySelector(".sg-optin-box");
        if (opt && !opt.checked) {
          (e.preventDefault(),
            e.stopImmediatePropagation(),
            rememberEmail(v),
            setUnlocked(),
            done.focus(),
            say("Your list is ready. Download the PDF or print it."));
          return;
        }
        try {
          sessionStorage.setItem("nono-day-pending", "1");
        } catch (x) {}
        rememberEmail(v);
        say("Sending\u2026");
      },
      !0,
    ));
  /* v8: no Save picture. Remove the button if the section still renders it. */
  var saveBtn = root.querySelector('[data-act="save"]');
  saveBtn && saveBtn.remove();
  var acts = root.querySelectorAll('[data-act="print"]');
  if (
    gate.querySelector("[data-posted]") ||
    (/customer_posted=true/.test(location.search) &&
      (function () {
        try {
          return sessionStorage.getItem("nono-day-pending");
        } catch (e) {}
      })())
  ) {
    try {
      sessionStorage.removeItem("nono-day-pending");
    } catch (e) {}
    ((unlocked = !0),
      (state.done = !0),
      setTimeout(function () {
        (gate.scrollIntoView({ block: "center" }),
          done.focus({ preventScroll: !0 }),
          say("Your list is ready. Download the PDF or print it."));
      }, 300));
  }
  (function () {
    var again = document.createElement("button");
    again.type = "button";
    again.className = "sg-again";
    again.textContent = "Send it to a different email";
    again.addEventListener("click", function () {
      email.value = "";
      showGate();
      email.focus();
    });
    done.appendChild(again);
  })();
  (state.done ? setUnlocked() : showGate(),
    (function () {
      var ep = form.querySelector("[data-sg-endpoint]"),
        EP = ep ? (ep.getAttribute("data-sg-endpoint") || "").trim() : "";
      if (GATE !== "full" || !/^https:\/\//.test(EP)) return;
      var busy = !1,
        sbtn2 = form.querySelector('[type="submit"]'),
        label = sbtn2.textContent,
        note = done.querySelector(".sg-mailnote");
      function finish(msg, live2) {
        (setUnlocked(),
          note && ((note.textContent = msg), (note.hidden = !1)),
          done.focus(),
          say(live2 || msg));
      }
      function toBlob(u) {
        for (
          var b = atob(u.split(",")[1]), a = new Uint8Array(b.length), i = 0;
          i < b.length;
          i++
        )
          a[i] = b.charCodeAt(i);
        return new Blob([a], { type: "image/png" });
      }
      function teaser(pdfBlob) {
        var src = root.dataset.pdfjs,
          wsrc = root.dataset.pdfjsWorker;
        if (!src || !window.Promise) return Promise.resolve(null);
        var work = (window.pdfjsLib ? Promise.resolve() : loadJS(src))
            .then(function () {
              var L = window.pdfjsLib;
              return (
                (L.GlobalWorkerOptions.workerSrc = wsrc),
                pdfBlob.arrayBuffer().then(function (b) {
                  return L.getDocument({
                    data: new Uint8Array(b),
                    isEvalSupported: !1,
                  }).promise;
                })
              );
            })
            .then(function (doc) {
              return doc.getPage(1).then(function (pg) {
                var W2 = 1120,
                  vp0 = pg.getViewport({ scale: 1 }),
                  sc = W2 / vp0.width,
                  vp = pg.getViewport({ scale: sc }),
                  top = Math.round((vp.height * 30) / 297),
                  H2 = Math.round(vp.height * 0.6),
                  c = document.createElement("canvas");
                ((c.width = W2), (c.height = H2));
                var x = c.getContext("2d");
                return (
                  (x.fillStyle = "#ffffff"),
                  x.fillRect(0, 0, W2, H2),
                  pg
                    .render({
                      canvasContext: x,
                      viewport: vp,
                      transform: [1, 0, 0, 1, 0, -top],
                    })
                    .promise.then(function () {
                      ((x.strokeStyle = "#E3DCCB"),
                        (x.lineWidth = 2),
                        x.beginPath(),
                        x.moveTo(1, H2),
                        x.lineTo(1, 1),
                        x.lineTo(W2 - 1, 1),
                        x.lineTo(W2 - 1, H2),
                        x.stroke());
                      var g = x.createLinearGradient(0, H2 * 0.55, 0, H2);
                      return (
                        g.addColorStop(0, "rgba(248,246,240,0)"),
                        g.addColorStop(0.7, "rgba(248,246,240,0.93)"),
                        g.addColorStop(1, "rgba(248,246,240,1)"),
                        (x.fillStyle = g),
                        x.fillRect(
                          0,
                          Math.floor(H2 * 0.55),
                          W2,
                          H2 - Math.floor(H2 * 0.55) + 1,
                        ),
                        doc.destroy(),
                        new Promise(function (res) {
                          c.toBlob(
                            function (b) {
                              res(b && b.size < 6e5 ? b : null);
                            },
                            "image/jpeg",
                            0.84,
                          );
                        })
                      );
                    })
                );
              });
            }),
          t = new Promise(function (res) {
            setTimeout(function () {
              res(null);
            }, 1e4);
          });
        return Promise.race([work, t]).catch(function () {
          return null;
        });
      }
      function go(e) {
        if ((e.preventDefault(), e.stopImmediatePropagation(), !busy)) {
          var v = email.value.trim();
          if (v.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v))
            return bad("Please check the email address.");
          ((err.hidden = !0), email.removeAttribute("aria-invalid"));
          var opt = form.querySelector(".sg-optin-box"),
            hp = form.querySelector('[name="website"]');
          ((busy = !0),
            (sbtn2.disabled = !0),
            sbtn2.setAttribute("aria-busy", "true"),
            (sbtn2.textContent = "Sending\u2026"),
            say("Sending\u2026"),
            select(null));
          var date = new Date().toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          });
          Promise.all([
            PDF.make(state, date).then(function (d) {
              return d.output("blob");
            }),
            PDF.png(PDF.sceneSVG(state, 1200, 900), 1200, 900).then(toBlob),
          ])
            .then(function (f) {
              return teaser(f[0]).then(function (t) {
                return ((f[2] = t), f);
              });
            })
            .then(function (f) {
              var fd = new FormData();
              (fd.append("email", v),
                (!opt || opt.checked) && fd.append("consent", "1"),
                fd.append("website", hp ? hp.value : ""),
                fd.append("pdf", f[0], "nature-trail-checklist.pdf"),
                fd.append("png", f[1], "our-nature-trail.png"),
                f[2] && fd.append("preview", f[2], "checklist-preview.jpg"));
              var ac = window.AbortController ? new AbortController() : null,
                t = setTimeout(function () {
                  ac && ac.abort();
                }, 3e4);
              return fetch(EP, {
                method: "POST",
                body: fd,
                mode: "cors",
                credentials: "omit",
                signal: ac && ac.signal,
              }).then(function (r) {
                return (
                  clearTimeout(t),
                  r
                    .json()
                    .catch(function () {
                      return {};
                    })
                    .then(function (j) {
                      return ((j.status = r.status), j);
                    })
                );
              });
            })
            .then(function (j) {
              if (j.ok) {
                (rememberEmail(v),
                  finish(
                    "We\u2019ve emailed you a private link to this PDF. It works for 30 days. You can also download it now.",
                    "Sent. Check your email.",
                  ));
                return;
              }
              if (j.error === "bad_email")
                return (
                  (busy = !1),
                  (sbtn2.disabled = !1),
                  sbtn2.removeAttribute("aria-busy"),
                  (sbtn2.textContent = label),
                  bad("Please check the email address.")
                );
              (rememberEmail(v),
                finish(
                  j.status === 429
                    ? "Lots of tries from here, so we didn\u2019t send another email. Download your PDF below."
                    : "We couldn\u2019t email it just now. Download your PDF below instead.",
                ));
            })
            .catch(function () {
              (rememberEmail(v),
                finish(
                  "We couldn\u2019t email it just now. Download your PDF below instead.",
                ));
            })
            .then(function () {
              ((busy = !1),
                (sbtn2.disabled = !1),
                sbtn2.removeAttribute("aria-busy"),
                (sbtn2.textContent = label));
            });
        }
      }
      (gate.addEventListener(
        "click",
        function (e) {
          e.target.closest &&
            e.target.closest('[type="submit"]') === sbtn2 &&
            go(e);
        },
        !0,
      ),
        gate.addEventListener(
          "submit",
          function (e) {
            e.target === form && go(e);
          },
          !0,
        ));
    })());
  function needGate() {
    return state.done
      ? !1
      : (gate.scrollIntoView({
          behavior: reduce ? "auto" : "smooth",
          block: "center",
        }),
        email.focus({ preventScroll: !0 }),
        say("Add your email first."),
        !0);
  }
  var wasOpen = null;
  (window.addEventListener("beforeprint", function () {
    ((wasOpen = []),
      list.querySelectorAll("details").forEach(function (d) {
        (wasOpen.push(d.open), (d.open = !0));
      }));
  }),
    window.addEventListener("afterprint", function () {
      wasOpen &&
        (list.querySelectorAll("details").forEach(function (d, i) {
          d.open = wasOpen[i];
        }),
        (wasOpen = null));
    }),
    root
      .querySelector('[data-act="print"]')
      .addEventListener("click", function () {
        needGate() || (select(null), window.print());
      }));
  var clr = root.querySelector('[data-act="clear"]'),
    armed = 0;
  /* v8: Start again lives right under the picture tools, not down by step 3 */
  (function () {
    var host = root.querySelector(".sg-stage");
    if (!host || !clr) return;
    clr.classList.remove("sg-cta", "ghost", "quiet");
    clr.classList.add("sg-restart-btn");
    clr.insertAdjacentHTML("afterbegin", '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    host.appendChild(clr);
    var oldActs = root.querySelector(".sg-acts");
    oldActs && !oldActs.querySelector("button") && oldActs.remove();
  })();
  function restartState() {
    clr.disabled = !state.items.length && !Object.keys(state.ticks).some(function (k) { return state.ticks[k]; });
  }
  clr.addEventListener("click", function () {
    if (!armed) {
      ((armed = 1),
        clr.classList.add("armed"),
        (clr.querySelector("span").textContent = "Tap again to clear"),
        say("Tap again to clear your scene and list."),
        setTimeout(function () {
          ((armed = 0),
            clr.classList.remove("armed"),
            (clr.querySelector("span").textContent = "Start again"));
        }, 4e3));
      return;
    }
    ((armed = 0),
      clr.classList.remove("armed"),
      (clr.querySelector("span").textContent = "Start again"),
      (state.items = []),
      (state.ticks = {}),
      (layer.innerHTML = ""),
      select(null));
    (drawBg(),
      drawList(),
      showGate(),
      restartState(),
      say("Cleared. Make a new picture, then get your new list in step 3."));
  });
  var PDF = {};
  function loadJS(u) {
    return new Promise(function (ok, no) {
      var s = document.createElement("script");
      ((s.src = u),
        (s.onload = ok),
        (s.onerror = no),
        document.head.appendChild(s));
    });
  }
  PDF.load = function (cb) {
    if (window.jspdf && window.NONO_PDF_KIT) return cb();
    Promise.all([
      window.jspdf ? 0 : loadJS(root.dataset.jspdf),
      window.NONO_PDF_KIT ? 0 : loadJS(root.dataset.pdfkit),
    ])
      .then(function () {
        var K = window.NONO_PDF_KIT;
        ((FONT_R = K.FONT_R),
          (FONT_B = K.FONT_B),
          (LOGO_SVG = K.LOGO_SVG),
          cb());
      })
      .catch(function () {
        say("Sorry, the PDF couldn\u2019t load. Please try again.");
      });
  };
  var FONT_R, FONT_B, LOGO_SVG;
  function pdfStar(d, x, y, r, fill, line) {
    var p = [], i, a, rr, dl = [];
    for (i = 0; i < 10; i++) {
      a = -Math.PI / 2 + (i * Math.PI) / 5;
      rr = i % 2 ? r * 0.45 : r;
      p.push([x + Math.cos(a) * rr, y + Math.sin(a) * rr]);
    }
    for (i = 1; i < 10; i++) dl.push([p[i][0] - p[i - 1][0], p[i][1] - p[i - 1][1]]);
    d.setFillColor.apply(d, fill);
    d.setDrawColor.apply(d, line);
    d.setLineWidth(0.25);
    d.lines(dl, p[0][0], p[0][1], [1, 1], "FD", !0);
  }
  ((PDF.sceneSVG = function (st, w, h) {
    var it = "";
    return (
      st.items.forEach(function (i) {
        it +=
          '<g transform="translate(' +
          i.x +
          " " +
          i.y +
          ") rotate(" +
          (i.r || 0) +
          ") scale(" +
          (i.f ? -i.s : i.s) +
          " " +
          i.s +
          ') translate(-50 -50)">' +
          A.items[i.type].svg +
          "</g>";
      }),
      '<svg xmlns="' +
        NS +
        '" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 800 600" width="' +
        w +
        '" height="' +
        h +
        '">' +
        A.scene(st.time, st.place) +
        it +
        "</svg>"
    );
  }),
    (PDF.png = function (svgText, w, h) {
      return new Promise(function (res, rej) {
        var img = new Image(),
          u = URL.createObjectURL(
            new Blob([svgText], { type: "image/svg+xml" }),
          );
        ((img.onload = function () {
          var c = document.createElement("canvas");
          ((c.width = w), (c.height = h));
          var x = c.getContext("2d");
          (x.drawImage(img, 0, 0, w, h),
            URL.revokeObjectURL(u),
            res(c.toDataURL("image/png")));
        }),
          (img.onerror = rej),
          (img.src = u));
      });
    }),
    (PDF.iconSVG = function (k2) {
      return (
        '<svg xmlns="' +
        NS +
        '" viewBox="-6 -6 112 112" width="160" height="160">' +
        A.items[k2].svg +
        "</svg>"
      );
    }),
    (PDF.pack = function (st) {
      return {
        v: 1,
        d: new Date().toISOString().slice(0, 10),
        p: st.place,
        t: st.time,
        i: st.items.map(function (i) {
          return [
            i.type,
            Math.round(i.x * 10) / 10,
            Math.round(i.y * 10) / 10,
            Math.round(i.s * 100) / 100,
            i.f ? 1 : 0,
            Math.round(i.r || 0),
          ];
        }),
      };
    }),
    (PDF.unpack = function (o) {
      return !o || o.v !== 1 || !A.places[o.p] || !A.times[o.t]
        ? null
        : {
            made: /^\d{4}-\d\d-\d\d$/.test(o.d || "") ? o.d : null,
            place: o.p,
            time: o.t,
            items: (o.i || [])
              .filter(function (a) {
                return A.items[a[0]];
              })
              .slice(0, MAX)
              .map(function (a) {
                return {
                  type: a[0],
                  x: +a[1],
                  y: +a[2],
                  s: Math.min(2.5, Math.max(0.3, +a[3])),
                  f: a[4] ? 1 : 0,
                  r: ((Math.round(+a[5] || 0) % 360) + 360) % 360,
                };
              }),
          };
    }),
    (PDF.link = function (st) {
      var j = JSON.stringify(PDF.pack(st));
      return (
        location.origin +
        location.pathname +
        "#pdf=" +
        btoa(unescape(encodeURIComponent(j)))
          .replace(/\+/g, "-")
          .replace(/\//g, "_")
          .replace(/=+$/, "")
      );
    }),
    (PDF.fromHash = function () {
      var m = location.hash.match(/^#pdf=([A-Za-z0-9_-]+)$/);
      if (!m) return null;
      try {
        var b = m[1].replace(/-/g, "+").replace(/_/g, "/");
        return PDF.unpack(JSON.parse(decodeURIComponent(escape(atob(b)))));
      } catch (e) {
        return null;
      }
    }),
    (PDF.make = function (st, date) {
      return new Promise(function (done2) {
        PDF.load(function () {
          var jsPDF = window.jspdf.jsPDF,
            d = new jsPDF({ unit: "mm", format: "a4", compress: !0 });
          (d.addFileToVFS("DMS-R.ttf", FONT_R),
            d.addFont("DMS-R.ttf", "DMS", "normal"),
            d.addFileToVFS("DMS-B.ttf", FONT_B),
            d.addFont("DMS-B.ttf", "DMS", "bold"));
          var NAV = [16, 57, 72],
            GR = [58, 91, 103],
            RULE = [213, 222, 226],
            ACC = [201, 74, 0],
            keys = Object.keys(A.items).filter(seasonal),
            jobs = [
              PDF.png(PDF.sceneSVG(st, 2400, 1800), 2400, 1800),
              PDF.png(LOGO_SVG, 640, 396),
            ],
            icons = {},
            pipPNG = {};
          A.pipSVG &&
            (jobs.push(PDF.png('<svg xmlns="' + NS + '" viewBox="0 0 100 100" width="96" height="96">' + A.pipSVG + "</svg>", 96, 96).then(function (u) { pipPNG.a = u; })),
            jobs.push(PDF.png('<svg xmlns="' + NS + '" viewBox="0 0 100 100" width="96" height="96">' + A.starSVG + "</svg>", 96, 96).then(function (u) { pipPNG.s = u; })));
          (keys.forEach(function (k2) {
            jobs.push(
              PDF.png(PDF.iconSVG(k2), 160, 160).then(function (u) {
                icons[k2] = u;
              }),
            );
          }),
            Promise.all(jobs).then(function (r) {
              var scene = r[0],
                logo = r[1];
              function foot(n) {
                (d.setDrawColor.apply(d, RULE),
                  d.setLineWidth(0.3),
                  d.setFont("DMS", "normal"),
                  d.setFontSize(9),
                  d.setTextColor.apply(d, GR),
                  d.text("Look, don\u2019t touch or eat. Go with an adult.", 14, 291),
                  d.text("nonoproblemo.com", 196, 291, { align: "right" }));
              }
              (d.addImage(logo, "PNG", 14, 11, 17, 10.5),
                d.setTextColor.apply(d, NAV),
                d.setFont("DMS", "bold"),
                d.setFontSize(17),
                d.text("Nature trail checklist", 105, 19, { align: "center" }),
                d.setFont("DMS", "normal"),
                d.setFontSize(9.5),
                d.setTextColor.apply(d, GR),
                d.text((function () {
                  var m = /^(\d{4})-(\d\d)-(\d\d)$/.exec(st.made || ""), t = m ? new Date(+m[1], m[2] - 1, +m[3]) : new Date(date);
                  isNaN(t) && (t = new Date());
                  return ("0" + t.getDate()).slice(-2) + "/" + ("0" + (t.getMonth() + 1)).slice(-2) + "/" + t.getFullYear();
                })(), 196, 18.2, { align: "right" }));
              var SW = 92,
                SH = 69,
                SX = (210 - SW) / 2,
                SY = 33;
              (d.setFillColor(248, 246, 240),
                d.roundedRect(SX - 3, SY - 3, SW + 6, SH + 6, 3, 3, "F"),
                d.addImage(scene, "PNG", SX, SY, SW, SH, void 0, "FAST"),
                d.setDrawColor.apply(d, NAV),
                d.setLineWidth(0.6),
                d.roundedRect(SX, SY, SW, SH, 1.5, 1.5, "S"),
                (function () {
                  var n = cleanName(st.kid).trim();
                  if (!n) return;
                  n = n + (/s$/i.test(n) ? "\u2019" : "\u2019s") + " picture";
                  d.setFont("DMS", "bold");
                  for (var fs = 10; fs > 6.5; fs -= 0.5) { d.setFontSize(fs); if (d.getTextWidth(n) + 8 <= SW * 0.8) break; }
                  var tw = d.getTextWidth(n) + 8, th = 6.4, tx = 105 - tw / 2, ty = SY + SH - 2 - th;
                  d.setFillColor(255, 255, 255); d.setDrawColor.apply(d, NAV); d.setLineWidth(0.45);
                  d.roundedRect(tx, ty, tw, th, 3.2, 3.2, "FD");
                  d.setTextColor.apply(d, NAV); d.text(n, 105, ty + 4.4, { align: "center" });
                })(),
                0);
              var top = SY + SH + 8;
              (d.setFont("DMS", "normal"),
                d.setFontSize(9.5),
                d.setTextColor.apply(d, GR),
                d.text(
                  "Take this on your walk and tick each thing you spot. Look, don\u2019t touch or eat.",
                  105,
                  27.5,
                  { align: "center" },
                ));
              var NC = 4,
                RH = 7.6,
                GH = 11.5,
                CW = 43.5,
                cols = [[], [], [], []],
                hh = [0, 0, 0, 0];
              (A.groups.forEach(function (g) {
                var ks = keys.filter(function (k2) {
                    return A.items[k2].g === g[0];
                  }),
                  c = hh.indexOf(Math.min.apply(null, hh));
                ks.length && (cols[c].push([g, ks]), (hh[c] += GH + ks.length * RH));
              }),
                cols.forEach(function (col, ci) {
                  var X = 14 + ci * (CW + 2.67),
                    W2 = CW - 2,
                    Y = top + 10;
                  col.forEach(function (gk) {
                    var g = gk[0];
                    (d.setFont("DMS", "bold"),
                      d.setFontSize(10.5),
                      d.setTextColor.apply(d, ACC),
                      d.text(
                        d.splitTextToSize(
                          g[2] === "Frogs" ? "Frogs and newts" : g[1],
                          W2,
                        )[0],
                        X,
                        Y,
                      ),
                      d.setDrawColor.apply(d, RULE),
                      d.setLineWidth(0.3),
                      d.line(X, Y + 1.8, X + W2, Y + 1.8),
                      (Y += 3),
                      gk[1].forEach(function (k2) {
                        var a = A.items[k2],
                          inPic = st.items.some(function (i) {
                            return i.type === k2;
                          }),
                          cx = X + 9.5,
                          cy = Y + RH / 2;
                        if (inPic && MARKER === "tint")
                          (d.setFillColor(255, 240, 179), d.roundedRect(X + 5.4, Y + 0.5, W2 - 5.4, RH - 1, 1.6, 1.6, "F"));
                        (d.setDrawColor.apply(d, NAV),
                          d.setLineWidth(0.35),
                          d.roundedRect(
                            X + 0.3,
                            Y + RH / 2 - 2.3,
                            4.6,
                            4.6,
                            0.7,
                            0.7,
                            "S",
                          ),
                          d.addImage(
                            icons[k2],
                            "PNG",
                            X + 6.4,
                            Y + RH / 2 - 3.1,
                            6.2,
                            6.2,
                          ),
                          inPic && MARKER === "ring" && (d.setDrawColor.apply(d, ACC), d.setLineWidth(0.55), d.circle(cx, cy, 3.45, "S")),
                          inPic && MARKER === "dot" && (d.setFillColor.apply(d, ACC), d.circle(X + 12.2, Y + RH / 2 - 2.2, 1.1, "F")),
                          d.setFont("DMS", "bold"),
                          d.setFontSize(9),
                          d.setTextColor.apply(d, NAV),
                          d.text(
                            d.splitTextToSize(a.short, W2 - 15.5 - (pts(k2) >= 5 ? 4.4 : pts(k2) * 2.9))[0],
                            X + 13.6,
                            Y + RH / 2 + 1.2,
                          ),
                          (function () {
                            if (!pipPNG.a) return;
                            var n = pts(k2), px = X + 13.6 + d.getTextWidth(d.splitTextToSize(a.short, W2 - 15.5 - (n >= 5 ? 4.4 : n * 2.9))[0]) + 1.2, py = Y + RH / 2 - 1.5;
                            if (n >= 5) d.addImage(pipPNG.s, "PNG", px, py - 0.4, 3.6, 3.6);
                            else for (var q = 0; q < n; q++) d.addImage(pipPNG.a, "PNG", px + q * 2.9, py, 2.8, 2.8);
                          })(),
                          (Y += RH));
                      }),
                      (Y += GH - 3));
                  });
                }),
                (window.__pdfBottom = Math.max.apply(null, hh) + top + 9),
                (function () {
                  /* points strip: key | My total | 3-step badge scale (circle the one you reached) */
                  if (!pipPNG.a) return;
                  var y0 = 255, i2, BX = 14, BW = 182, BH = 27;
                  d.setFillColor(253, 246, 234); d.roundedRect(BX, y0, BW, BH, 4, 4, "F");
                  /* key */
                  d.setFont("DMS", "bold"); d.setFontSize(9); d.setTextColor.apply(d, NAV); d.text("Points", 20, y0 + 6);
                  d.setFont("DMS", "normal"); d.setFontSize(8.5); d.setTextColor.apply(d, GR);
                  LEVELS.forEach(function (kv, j2) {
                    var ky = y0 + 8.6 + j2 * 4.4, n = kv[0];
                    if (n >= 5) d.addImage(pipPNG.s, "PNG", 20, ky - 0.4, 3.4, 3.4);
                    else for (i2 = 0; i2 < n; i2++) d.addImage(pipPNG.a, "PNG", 20 + i2 * 2.9, ky, 2.7, 2.7);
                    d.text(kv[1], 30.5, ky + 2.4);
                  });
                  /* my total */
                  d.setFont("DMS", "bold"); d.setFontSize(12); d.setTextColor.apply(d, NAV); d.text("My total", 62, y0 + 6.5);
                  d.setFillColor(255, 255, 255); d.setDrawColor.apply(d, NAV); d.setLineWidth(0.7); d.roundedRect(62, y0 + 9, 30, 14, 2.5, 2.5, "FD");
                  /* badge scale */
                  d.setFont("DMS", "bold"); d.setFontSize(10); d.text("Circle the badge you reached", 101, y0 + 6.5);
                  var bw = 27, gap = 4.5, bx0 = 101;
                  d.setDrawColor(226, 205, 180); d.setLineWidth(0.8); d.line(bx0 + bw / 2, y0 + 16, bx0 + 2 * (bw + gap) + bw / 2, y0 + 16);
                  A.badges.forEach(function (bd, j2) {
                    var bx = bx0 + j2 * (bw + gap);
                    d.setFillColor(255, 255, 255); d.setDrawColor.apply(d, ACC); d.setLineWidth(0.6);
                    d.roundedRect(bx, y0 + 9, bw, 14, 7, 7, "FD");
                    d.setFont("DMS", "bold"); d.setFontSize(9.5); d.setTextColor.apply(d, NAV); d.text(bd[0], bx + bw / 2, y0 + 15, { align: "center" });
                    d.setFont("DMS", "normal"); d.setFontSize(8); d.setTextColor.apply(d, GR); d.text(bd[1] + "+ points", bx + bw / 2, y0 + 19.6, { align: "center" });
                  });
                })(),
                foot(1),
                d.setProperties({
                  title: "Nature trail checklist",
                  creator: "Nono Problemo",
                }),
                done2(d));
            }));
        });
      });
    }),
    (PDF.save = function (st) {
      var when = st.made ? new Date(st.made + "T12:00:00") : new Date();
      return PDF.make(
        st,
        when.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
      ).then(function (d) {
        (d.save("nature-trail-checklist.pdf"),
          say("PDF saved to this device."));
      });
    }));
  var pdfBtn = root.querySelector('[data-act="pdf"]');
  pdfBtn &&
    pdfBtn.addEventListener("click", function () {
      needGate() || (select(null), PDF.save(state));
    });
  var fromLink = PDF.fromHash(),
    ready = root.querySelector(".sg-ready");
  (fromLink &&
    ready &&
    ((ready.hidden = !1),
    ready.querySelector("button").addEventListener("click", function () {
      PDF.save(fromLink);
    })),
    (window.__scene = {
      pdf: PDF,
      link: function () {
        return PDF.link(state);
      },
      add: add,
      select: select,
      state: state,
      set: function (id, x, y, s) {
        var it = find(id);
        ((it.x = x), (it.y = y), s && (it.s = s), place(it), save());
      },
    }));
  var wf = root.querySelector(".sg-walkform");
  if (wf) {
    var wq = wf.querySelector("#sg-pc"),
      we = wf.querySelector(".sg-err"),
      M = "https://www.google.com/maps/search/?api=1&query=";
    (wf.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = wq.value.trim();
      if (v.length < 2) {
        ((we.hidden = !1), wq.setAttribute("aria-invalid", "true"), wq.focus());
        return;
      }
      ((we.hidden = !0),
        wq.removeAttribute("aria-invalid"),
        window.open(
          M + encodeURIComponent("nature trails near " + v),
          "_blank",
          "noopener",
        ));
    }),
      root
        .querySelector('[data-act="nearme"]')
        .addEventListener("click", function () {
          window.open(
            M + encodeURIComponent("nature trails near me"),
            "_blank",
            "noopener",
          );
        }));
  }
  (restartState(),
    drawBg(),
    drawTray(),
    state.items.forEach(function (it) {
      render(it, !1);
    }),
    select(null),
    drawList());
})();

